<shared-modal [mobile]="sharedService.screenSize !== 'l'">
  <!-- header -->
  <h2 slot="header">Editar chave de disparo</h2>

  <!-- body -->
  <div class="flex flex-col gap-3">
    <input placeholder="Nome" [(ngModel)]="name" [disabled]="loading" />
    <div class="flex gap-3">
      <input
        class="w-20"
        no-clear
        placeholder="País"
        maxlength="2"
        [value]="number.countryCode"
        (input)="setNumber('countryCode', $event, 3)"
        [readonly]="id"
        [disabled]="loading"
      />
      <input
        class="w-20"
        no-clear
        placeholder="DDD"
        [value]="number.areaCode"
        (input)="
          setNumber('areaCode', $event, number.countryCode === '55' ? 2 : 4)
        "
        [readonly]="id"
        [disabled]="loading"
      />
      <input
        class="flex-1"
        no-clear
        placeholder="Número"
        [value]="number.number"
        (input)="
          setNumber('number', $event, number.countryCode === '55' ? 8 : 15)
        "
        [readonly]="id"
        [disabled]="loading"
      />
    </div>
    <!-- tags -->
    @if (userService.organization()?.userTags?.length) {
      <hr />
      <h2>Categorias</h2>
      <div class="flex gap-2 flex-wrap">
        @for (tag of userService.organization()?.userTags; track tag) {
          <div
            class="blu-tag cursor-pointer"
            [ngClass]="{ active: tags.includes(tag) }"
            (click)="toggleTag(tag)"
            [style.pointer-events]="loading ? 'none' : 'auto'"
          >
            <span class="material-symbols-rounded text-black/40">label</span
            >{{ tag }}
          </div>
        }
      </div>
    }
    <!-- export contacts as csv -->
    @if (id) {
      <hr />
      <li
        class="blu-menu-item"
        (click)="exportContactsToCsv()"
        [style.pointer-events]="loading ? 'none' : 'auto'"
      >
        <span class="material-symbols-rounded">file_download</span>
        <span>Exportar lista de contatos (.csv)</span>
      </li>
    }
  </div>

  <!-- footer -->
  @if (id) {
    <button
      class="tertiary mr-auto"
      slot="footer"
      (click)="deleteUser()"
      [disabled]="loading"
    >
      Deletar
    </button>
  }
  <button
    slot="footer"
    class="secondary"
    (click)="sharedService.closeModal(route)"
    [disabled]="loading"
  >
    Cancelar
  </button>
  <button
    slot="footer"
    [disabled]="
      !name ||
      !number.countryCode ||
      !number.areaCode ||
      !number.number ||
      loading
    "
    (click)="saveUser()"
  >
    {{ loading ? 'Salvando...' : 'Confirmar' }}
  </button>
</shared-modal>
